export default "__VITE_ASSET__CKDq6gQV__"